import { useState } from 'react';
import messages from '../../../locales/messages';
import {
  ThanksModal,
  thanksTable,
  ThanksTableVerbiage,
} from 'src/common/utils/ThanksModal';
import { createUseTranslation } from 'src/common/hooks/widgets/useTranslation';
import { useQradarEDRSelector } from '../../../lib/redux/hooks';
import { convertToString } from '../../../lib/utils';

export interface thanksProps {
  bpName: string;
  demo?: string;
}

const Thanks = ({ bpName }: thanksProps) => {
  const AEMMessages = useQradarEDRSelector(
    (state) => state.translations.messages,
  );
  const useTranslation = createUseTranslation(messages, AEMMessages);

  const [showThanksModal, setShowThanksModal] = useState(true);

  const titleThanks: ThanksTableVerbiage[] = [
    { group: 'title', value: useTranslation('thank_text') },
    {
      group: 'widgetTitle2',
      value: '',
    },
  ];

  const widgetTitleThanks: thanksTable[] = [
    {
      group: 'widgetTitle1',
      value: '',
    },
  ];
  const contentThanks: thanksTable[] = [];
  bpName &&
    contentThanks.push({
      group: convertToString(useTranslation('thank_bp_title', true)),
      value: bpName,
    });

  const buttonThanks: thanksTable[] = [
    {
      group: 'button1',
      value: convertToString(useTranslation('thank_return_assessment', true)),
    },
  ];

  return (
    <div>
      <ThanksModal
        showThanksModal={showThanksModal}
        pageTitle="AI Solutions Advisor Page"
        object="AI Solutions Advisor Page"
        productTitle={'AI Solutions Advisor'}
        pageUrl={'/products/watsonx-orchestrate/pricing'}
        location={'Assessment'}
        titleThanks={titleThanks}
        widgetTitleThanks={widgetTitleThanks}
        contentThanks={contentThanks}
        buttonThanks={buttonThanks}
        setShowThanksModal={setShowThanksModal}
      />
    </div>
  );
};

export default Thanks;
